module.exports = __webpack_public_path__ + "static/media/sl1.616a27bb.jpg";